import { Pipe, PipeTransform } from "@angular/core";
import { bookAuthorModel } from "@shared/model/bookModels/book-model";

@Pipe({
  standalone: true,
  name: 'authorSort'
})
export class AuthorSortPipe implements PipeTransform {
  transform(bookAuthors: bookAuthorModel[]): bookAuthorModel[] {
    //? Making a deep copy of book authors
    if (!bookAuthors) return [];

    const authorWithName: bookAuthorModel[] = [];
    bookAuthors.forEach(author => {
      if (author.fullName || author.name) {
        authorWithName.push(author);
      }
    });

    authorWithName?.sort((a, b) => {
      if (a.type!.toLocaleLowerCase() < b.type!.toLocaleLowerCase())
        return -1;
      if (a.type!.toLocaleLowerCase() > b.type!.toLocaleLowerCase())
        return 1;
      return 0
    });

    return authorWithName;
  }
}
